import { WomenInstructor } from '@components/common/icons/custom-icons'
import {
  ArrowTrendingUpIcon,
  ClockIcon,
  UsersIcon,
} from '@heroicons/react/24/outline'
import { DollarSign } from 'react-feather'
import { FastlyImage } from '@components/common/image'

const TEACHER_STATS = [
  {
    value: '90%',
    label: 'Women educators',
    description:
      'A community led by women educators building meaningful, long-term teaching careers that fit real lives.',
    textColorClass: 'text-violet-100',
    bgLightClass: 'bg-violet-50',
    hoverBgClass: 'hover:bg-violet-50',
    hoverBorderClass: 'hover:border-violet-100',
    icon: <WomenInstructor className="h-8 w-8" />,
  },
  {
    value: '33%',
    label: 'higher earning potential',
    description:
      'Teaching that respects time and skill with clear pathways to grow income as experience grows.',
    textColorClass: 'text-blue-200',
    bgLightClass: 'bg-blue-100',
    hoverBgClass: 'hover:bg-blue-100',
    hoverBorderClass: 'hover:border-blue-200',
    icon: <ArrowTrendingUpIcon className="h-8 w-8" />,
  },
  {
    value: '1000',
    label: 'active teachers',
    description:
      'A trusted, growing community of educators teaching consistently as Codingal scales globally.',
    textColorClass: 'text-orange2-400',
    bgLightClass: 'bg-orange2-50',
    hoverBgClass: 'hover:bg-orange2-50',
    hoverBorderClass: 'hover:border-orange2-400',
    icon: <UsersIcon className="h-8 w-8" />,
  },
  {
    value: 'INR 17 Crore',
    label: 'paid out to teachers in 2025',
    description:
      'Reliable income earned through real classrooms, delivered on time and at scale.',
    textColorClass: 'text-green-100',
    bgLightClass: 'bg-green-50',
    hoverBgClass: 'hover:bg-green-50',
    hoverBorderClass: 'hover:border-green-100',
    icon: <DollarSign size={32} />,
  },
  {
    value: '75 Million',
    label: 'teaching minutes delivered in 2025',
    description:
      'Millions of moments where teachers helped learners understand, build, and gain confidence.',
    textColorClass: 'text-red-200',
    bgLightClass: 'bg-red-100',
    hoverBgClass: 'hover:bg-red-100',
    hoverBorderClass: 'hover:border-red-200',
    icon: <ClockIcon className="h-8 w-8" />,
  },
]

const TeacherFirstStats = () => (
  <div className="py-12 lg:py-16 bg-blue-50 bg-opacity-25">
    <div className="px-5 container mx-auto">
      {/* Section heading */}
      <div className="text-center mb-12">
        <h2 className="max-w-4xl mx-auto pb-3 text-2xl text-center text-grey lg:text-4xl font-600">
          Teachers first, always.
        </h2>
        <p className="text-lg text-grey max-w-4xl mx-auto">
          Teaching that grows with you.
          <br />
          Fair pay. Flexible work. Support that helps educators do their best
          work.
        </p>
      </div>

      {/* Stats cards */}
      <div className="flex flex-wrap gap-4 justify-center">
        {TEACHER_STATS.map(
          ({
            value,
            label,
            description,
            textColorClass,
            bgLightClass,
            hoverBgClass,
            hoverBorderClass,
            icon,
          }) => (
            <div
              key={value}
              className={`p-3 flex flex-col max-w-sm h-56 w-80 xl:w-full items-center justify-center md:justify-start text-center bg-white border border-blue-100 rounded-xl shadow-md transition-all duration-300 ${hoverBgClass} ${hoverBorderClass}`}
            >
              <span
                className={`${textColorClass} relative bg-opacity-50 p-3 self-start -mb-8`}
              >
                <span className="relative z-10">{icon}</span>
                <span
                  className={`absolute bg-opacity-75 top-0 left-0 rounded-full h-full w-full ${bgLightClass}`}
                  style={{ filter: 'blur(10px)' }}
                />
              </span>
              <p className={`text-4xl md:text-5xl ${textColorClass} font-600`}>
                {value}
              </p>
              <p className="font-600">{label}</p>
              <p>{description}</p>
            </div>
          )
        )}
      </div>
    </div>

    <div className="w-full mt-16 hidden md:block">
      <FastlyImage
        src="/images/about-us/assets/teacher-students-v2.png"
        height={423}
        width={1280}
        alt="Students and Teachers"
        className="mx-auto"
      />
    </div>
  </div>
)

export default TeacherFirstStats
